var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7625 22H13.75C13.3834 22 13.0625 21.6792 13.0625 21.3125V15.675C13.0625 14.4834 12.1459 13.5667 10.9542 13.5667C9.76254 13.5667 8.84587 14.4834 8.84587 15.675V21.3125C8.84587 21.6792 8.52504 22 8.15837 22H1.14587C0.779207 22 0.458374 21.6792 0.458374 21.3125V10.5417C0.458374 10.3584 0.550041 10.175 0.641707 10.0375L10.4959 0.183362C10.7709 -0.0916382 11.1834 -0.0916382 11.4584 0.183362L21.3125 10.0375C21.4959 10.2209 21.5875 10.5417 21.45 10.7709C21.45 10.8167 21.4042 10.8167 21.4042 10.8625V21.3125C21.45 21.6792 21.1292 22 20.7625 22ZM14.4375 20.625H20.075V10.725L11 1.65003L1.83337 10.8167V20.625H7.47087V15.675C7.47087 13.7042 8.98337 12.1917 10.9542 12.1917C12.925 12.1917 14.4375 13.7042 14.4375 15.675V20.625V20.625Z",
    fill: "#262626"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.0d84b705aeb2c7d2689ade96190b1708.svg";
export { ForwardRef as ReactComponent };